import { TLinkHighlighterText } from './types'
import { Link } from '../Link'
import { websiteValidationRegex } from '../../helper/common'

export const LinkHighlighter = ({
  text,
  linkClassName
}: TLinkHighlighterText) => {
  const onLinkClick = (url: string) => {
    window.open(
      /(http(s?)):\/\//i.test(url) ? url : `https://${url}`,
      '_blank',
      'noreferrer'
    )
  }

  if (text && websiteValidationRegex.test(text))
    return (
      <Link to={''} className={linkClassName} onClick={() => onLinkClick(text)}>
        {text}
      </Link>
    )

  return <>{text}</>
}
